export default class DateMaster {
  static parseUTC(utcString) {
    if (utcString) {
      return Date.parse(utcString);
    } else {
      return null;
    }
  }

  static format(unformattedDate) {
    return new Date(unformattedDate).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }

  static addDays(dateValue, days) {
    const futureDate = new Date(dateValue);
    futureDate.setDate(futureDate.getDate() + days);
    return futureDate;
  }

  // Credit to https://stackoverflow.com/questions/3177836/how-to-format-time-since-xxx-e-g-4-minutes-ago-similar-to-stack-exchange-site
  static timeSince(dateInteger) {
    const date = new Date(dateInteger);
    let seconds = Math.floor((new Date() - date) / 1000);
    let interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
      return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }
}



// WEBPACK FOOTER //
// ./src/stores/utils/date_master.js